import { Box, styled, Typography } from '@mui/material';

export const OverlayRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    width: 'fit-content',
    ...theme.mixins.glassOverlay,
    padding: theme.spacing(0.5),
    borderRadius: `${theme.shape.borderRadius}px`,
    gap: theme.spacing(1),
}));

export const OverlayLabel = styled(Typography)({
    fontSize: 11,
    lineHeight: '11px',
    display: 'flex',
    alignItems: 'center',
    fontVariantNumeric: 'tabular-nums',
    fontFamily: 'Roboto Mono',
});
